import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check_circle",
  "use": "check_circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 16 16\" id=\"check_circle\"><path d=\"M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8Zm4.46 5.332L7.537 10.87a.612.612 0 0 1-.845.072L3.615 8.481a.616.616 0 0 1 .769-.962l2.621 2.097 4.535-5.102a.615.615 0 1 1 .92.818Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol